import { Form, Modal, notification, Select } from "antd";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { closeModal } from "store/slices/modalsSlice";
import {
  changeTutorialStatus,
  getTutorialById,
} from "store/slices/tutorialsSlice";

const EditTutorialStatusModal = () => {
  const { t } = useTranslation();
  const [form] = Form?.useForm();
  const dispatch = useDispatch();
  const { isModalOpen, modalType, modalProps } = useSelector(
    (state) => state?.modals
  );
  const { tutorial, loading } = useSelector((state) => state?.tutorials);
  const open = isModalOpen && modalType === "edit_tutorial_status";

  useEffect(() => {
    if (open && modalProps?.tutorialId) {
      dispatch(getTutorialById(modalProps?.tutorialId));
    }
  }, [dispatch, modalProps?.tutorialId, open]);

  useEffect(() => {
    if (tutorial && open) {
      form?.setFieldsValue({
        status: tutorial?.status,
      });
    }
  }, [form, tutorial, open]);

  const handleCancel = () => {
    form?.resetFields();
    dispatch(closeModal());
  };

  const handleOk = async () => {
    try {
      const values = await form?.validateFields();
      await dispatch(
        changeTutorialStatus({
          id: modalProps?.tutorialId,
          status: values?.status,
        })
      )?.unwrap();

      notification?.success({
        message: t("tutorials.crud.form.status.success"),
        duration: 3,
      });
      handleCancel();
    } catch (error) {
      notification?.error({
        message: t("tutorials.crud.form.status.error"),
        description: error?.message || t("common.error.generic"),
        duration: 4,
      });
    }
  };

  return (
    <Modal
      title={t("tutorials.crud.form.status.title")}
      open={open}
      onOk={handleOk}
      onCancel={handleCancel}
      confirmLoading={loading}
      destroyOnClose={true}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="status"
          label={t("tutorials.crud.form.label.status")}
          rules={[
            {
              required: true,
              message: t("tutorials.crud.form.status.required"),
            },
          ]}
        >
          <Select>
            <Select.Option value="draft">
              {t("tutorials.status.draft")}
            </Select.Option>
            <Select.Option value="published">
              {t("tutorials.status.published")}
            </Select.Option>
            <Select.Option value="archived">
              {t("tutorials.status.archived")}
            </Select.Option>
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditTutorialStatusModal;
